import { AbuseReportDispatcher } from 'Roblox';
import angular from "angular";
import notificationStreamModule from "../notificationStreamModule";

function gameUpdatesService(httpService, $q, $log, urlService, gameUpdatesConstants, $window) {
    "ngInject";
    var endpoints = gameUpdatesConstants.endpoints,
        apiParams = gameUpdatesConstants.apiParams;

    // Helper to invoke a multi-get endpoint with input batches of acceptable size.
    function batchMultiGet(endpoint, paramValues, batchSize, paramsBuilder) {
        var promises = [],
            params,
            batchStartIndex = 0,
            batch;

        batch = paramValues.slice(batchStartIndex, batchSize);

        while (batch.length > 0 && batchStartIndex < paramValues.length) {
            params = paramsBuilder(batch);

            promises.push(httpService.httpGet(endpoint, params));

            batchStartIndex = batchStartIndex + batchSize;
            batch = paramValues.slice(batchStartIndex, batchStartIndex + batchSize);
        }

        return $q.all(promises);
    }

    // Helper to get game icons via Thumbnails API.
    function multiGetGameIconsAsync(universeIds) {
        var endpoint = endpoints.getGameIconsEndpoint();

        return batchMultiGet(
            endpoint, universeIds, apiParams.gameIconBatchSize,
            function (batch) {
                return {
                    size: apiParams.gameIconSize,
                    format: apiParams.gameIconFormat,
                    universeIds: batch
                };
            }
        ).then(
            function (results) {
                var gameIcons = {};

                if (!results || results.length === 0) {
                    return null;
                }

                angular.forEach(results, function (result) {
                    if (result && result.data) {
                        angular.forEach(result.data, function (item) {
                            // Associate game icon to universe ID.
                            gameIcons[item.targetId] = item.imageUrl;
                        });
                    }
                });

                return gameIcons;
            }
        );
    }

    // Helper to get game playability.
    function multiGetPlaceDetailsAsync(placeIds) {
        var endpoint = endpoints.getGameDetailsEndpoint();

        return batchMultiGet(
            endpoint, placeIds, apiParams.placeDetailBatchSize,
            function (batch) {
                return {
                    placeIds: batch
                };
            }
        ).then(
            function (results) {
                var placeDetails = {}, imageTokens = [];

                if (!results || results.length === 0) {
                    return null;
                }

                angular.forEach(results, function (result) {
                    if (!result) {
                        return;
                    }

                    angular.forEach(result, function (item) {
                        placeDetails[item.placeId] = {
                            universeId: item.universeId,
                            isPlayable: item.isPlayable,
                            imageToken: item.imageToken
                        };
                    });
                });

                return placeDetails;
            }
        );
    }

    // Helper to retrieve latest game updates.
    function multiGetGameUpdatesAsync(universeIds, sinceDateTime) {
        // sinceDateTime is not being used right now because the EventDate from notifications stream does not return the correct date for now.
        var endpoint = endpoints.getGameUpdatesEndpoint();

        return batchMultiGet(endpoint, universeIds, apiParams.gameUpdateBatchSize,
            function (batch) {
                return {
                    universeIds: batch
                };
            }
        ).then(
            function (results) {
                var gameUpdates = [];

                if (!results || results.length === 0) {
                    return null;
                }

                angular.forEach(results, function (result) {
                    if (!result) {
                        return;
                    }

                    angular.forEach(result, function (item) {
                        gameUpdates.push(item);
                    });
                });

                return gameUpdates;
            }
        );
    }

    return {
        markGameUpdateReadAsync: function (universeId, createdOn, currentUserId) {
            var endpoint = endpoints.getReadEndpoint();

            var params = {
                universeId: universeId,
                createdOn: createdOn.toString(),
                currentUserId: currentUserId
            };

            return httpService.httpPost(endpoint, params);
        },

        markGameUpdateInteractedAsync: function (universeId, createdOnKey, interactionType, currentUserId) {
            var endpoint = endpoints.getInteractedEndpoint();

            var params = {
                universeId: universeId,
                createdOnKey: createdOnKey,
                interactionType: interactionType,
                currentUserId: currentUserId
            };

            return httpService.httpPost(endpoint, params);
        },

        multiGetPlaceDetailsAsync: function (placeIds) {
            if (!placeIds || placeIds.length === 0) {
                return $q(function (resolve, reject) {
                    resolve(null);
                });
            }

            return multiGetPlaceDetailsAsync(placeIds);
        },

        multiGetGameIconsAsync: function (universeIds) {
            if (!universeIds || universeIds.length === 0) {
                return $q(function (resolve, reject) {
                    resolve(null);
                });
            }

            return multiGetGameIconsAsync(universeIds);
        },

        multiGetGameUpdatesAsync: function (universeIds, sinceDateTime) {
            if (!universeIds || universeIds.length === 0) {
                return $q(function (resolve, reject) {
                    resolve(null);
                });
            }

            return multiGetGameUpdatesAsync(universeIds, sinceDateTime);
        },

        getGameFollowingsForUserAsync: function (userId) {
            var endpoint = endpoints.getGameFollowingsEndpoint(userId);
            return httpService.httpGet(endpoint, {});
        },

        followGameAsync: function (userId, universeId) {
            var endpoint = endpoints.getFollowGameEndpoint(userId, universeId);
            return httpService.httpPost(endpoint, {});
        },

        unfollowGameAsync: function (userId, universeId) {
            var endpoint = endpoints.getFollowGameEndpoint(userId, universeId);
            return httpService.httpDelete(endpoint, {});
        },

        reportAbuse: function (universeId, gameUpdateCreatedOn) {
            var url = urlService.getAbsoluteUrl(endpoints.getAbuseReportUrl(universeId, gameUpdateCreatedOn, encodeURIComponent($window.location.href)));

            if (AbuseReportDispatcher) {
                AbuseReportDispatcher.triggerUrlAction(url);
            }
            else {
                $window.location.href = url;
            }
        }
    };
}

notificationStreamModule.factory("gameUpdatesService", gameUpdatesService);

export default gameUpdatesService;